import React from "react";
import { useState, useContext, useEffect } from 'react'

import { useTranslation } from "react-i18next";

import { I18nContext } from '../../context/I18nProvider'
import api from '../../api/Api'

import { useForm } from "react-hook-form";

import Translate from "../../i18n/Translate";

const ContactForm = () => {

  const { language } = useContext(I18nContext)

  const [isSubmitting, setIsSubmitting] = useState({
    loading: false,
    error: null,
    response: null,
  })

  const [, setSendedForm] = useState(false)

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
} = useForm()

  const { t } = useTranslation();

  const onSubmit = async (data) => {
    // creamos un estado de carga
    setIsSubmitting({ loading: true, error: null })
    
    // Espermos la respuesta del servidor
    try {
        const apiData = await api.contact.default({ ...data, language })
        setIsSubmitting({ loading: false, response: apiData })
    } catch (error) {
        console.error(error)
        setIsSubmitting({ loading: false, error: error })
    }
  }

  useEffect(() => {
    if (isSubmitting.response) {
        setSendedForm(isSubmitting.response.status)
        //Si la respuesta es TRUE reseteo el formulario
        isSubmitting.response.status && reset()
    }
  }, [isSubmitting])

  let name = register("name", {
    required: `${t("contact.form.required")}`,
    pattern: {
      value:
        /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/g,
      message: `${t("contact.form.error")}`,
    },
  });

  let email = register("email", {
    required: `${t("contact.form.required")}`,
    pattern: {
      value:
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
      message: `${t("contact.form.error")}`,
    },
  });

  let subject = register("subject", {
    required: `${t("contact.form.required")}`,
    pattern: {
      value:
        /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/g,
      message: `${t("contact.form.error")}`,
    },
  });

  let message = register("message", {
    required: `${t("contact.form.required")}`,
    pattern: {
      value:
        /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/g,
      message: `${t("contact.form.error")}`,
    },
  });

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        {/* Nombre */}
        <div
          className={
            errors.name ? "contact__form__group error" : "contact__form__group"
          }
        >
          <label htmlFor="name">
            <Translate langkey="contact.form.labelname" />
          </label>
          <input
            type="text"
            name="name"
            id="name"
            {...name}
            aria-label="name"
            aria-invalid={errors.name ? "true" : "false"}
          />
          {errors.name && <small role="alert"> {errors.name.message}</small>}
        </div>

        {/* Correo */}
        <div
          className={
            errors.email ? "contact__form__group error" : "contact__form__group"
          }
        >
          <label htmlFor="email">
            <Translate langkey="contact.form.labelemail" />
          </label>
          <input
            type="email"
            id="email"
            {...email}
            aria-label="email"
            aria-invalid={errors.email ? "true" : "false"}
          />
          {errors.email && <small role="alert"> {errors.email.message}</small>}
        </div>

        {/* Asunto */}
        <div
          className={
            errors.subject
              ? "contact__form__group error"
              : "contact__form__group"
          }
        >
          <label htmlFor="subject">
            <Translate langkey="contact.form.labelsubject" />
          </label>
          <input
            type="text"
            id="subject"
            {...subject}
            aria-label="subject"
            aria-invalid={errors.subject ? "true" : "false"}
          />
          {errors.subject && (
            <small role="alert"> {errors.subject.message}</small>
          )}
        </div>

        {/* Mensaje */}
        <div
          className={
            errors.message
              ? "contact__form__group error"
              : "contact__form__group"
          }
        >
          <label htmlFor="subject">
            <Translate langkey="contact.form.labelmessage" />
          </label>
          <input
            type="text"
            id="message"
            {...message}
            aria-label="message"
            aria-invalid={errors.message ? "true" : "false"}
          />
          {errors.message && (
            <small role="alert"> {errors.message.message}</small>
          )}
        </div>

        <button type="submit">
          <Translate langkey="contact.form.button" />
        </button>
      </form>
    </>
  );
};

export default ContactForm;
